import { render, staticRenderFns } from "./day-configurator-format-modal.vue?vue&type=template&id=435c8f83&scoped=true&"
import script from "./day-configurator-format-modal.vue?vue&type=script&lang=js&"
export * from "./day-configurator-format-modal.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-format-modal.vue?vue&type=style&index=0&id=435c8f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c8f83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435c8f83')) {
      api.createRecord('435c8f83', component.options)
    } else {
      api.reload('435c8f83', component.options)
    }
    module.hot.accept("./day-configurator-format-modal.vue?vue&type=template&id=435c8f83&scoped=true&", function () {
      api.rerender('435c8f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/modals/day-configurator-format-modal.vue"
export default component.exports